const animation = {
  v: "5.9.0",
  fr: 60,
  ip: 0,
  op: 60,
  w: 320,
  h: 320,
  nm: "dragArea",
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "HalfCircle",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.134],
            y: [0.302]
          },
          t: 7,
          s: [255.577]
        }, {
          t: 60,
          s: [155.577]
        }],
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.667,
            y: 0.472
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 13,
          s: [160, 160, 0],
          to: [0, 0, 0],
          ti: [28.266, 28.984, 0]
        }, {
          i: {
            x: 0.667,
            y: 1
          },
          o: {
            x: 0.319,
            y: 1
          },
          t: 29,
          s: [121.164, 100.484, 0],
          to: [-28.266, -28.984, 0],
          ti: [0, 0, 0]
        }, {
          t: 60,
          s: [62, 64.5, 0]
        }],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0.166, -0.033], [0, -9.389], [9.389, 0], [-0.001, 8.75]],
            o: [[9.389, 0], [0, 9.389], [0.236, 0.059], [0.001, -8.75]],
            v: [[0, -17.167], [17, -0.167], [0, 16.833], [-0.005, -0.229]],
            c: true
          },
          ix: 2
        },
        nm: "Tracé 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.254901960784, 0.545098039216, 0.360784313725, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: "Fond 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [6, 0],
          ix: 1
        },
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.178, 0.178],
              y: [0.135, 0.135]
            },
            t: 13,
            s: [0, 0]
          }, {
            t: 40,
            s: [200, 200]
          }],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transformer "
      }],
      nm: "Ellipse 1",
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "Rectangle",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.163],
            y: [0.39]
          },
          t: 13,
          s: [252.738]
        }, {
          t: 60,
          s: [362.738]
        }],
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 13,
          s: [160, 160, 0],
          to: [0, 0, 0],
          ti: [-35.027, 16.005, 0]
        }, {
          i: {
            x: 0.667,
            y: 1
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 29,
          s: [227.973, 140.505, 0],
          to: [35.027, -16.005, 0],
          ti: [0, 0, 0]
        }, {
          t: 60,
          s: [275.5, 72.5, 0]
        }],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 50, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ty: "rc",
        d: 1,
        s: {
          a: 0,
          k: [50, 50],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: "Rectangle Path 1",
        mn: "ADBE Vector Shape - Rect",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.623529411765, 0.858823529412, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.222, 0.222],
              y: [0.315, 0.315]
            },
            t: 13,
            s: [0, 0]
          }, {
            i: {
              x: [0.833, 0.833],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 40,
            s: [120, 120]
          }, {
            t: 60,
            s: [140, 140]
          }],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transformer "
      }],
      nm: "Rectangle 1",
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: "Square",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 13,
          s: [160, 160, 0],
          to: [0, 0, 0],
          ti: [-15.191, -19.222, 0]
        }, {
          i: {
            x: 0.667,
            y: 1
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 32.5,
          s: [199.809, 184.278, 0],
          to: [15.191, 19.222, 0],
          ti: [0, 0, 0]
        }, {
          t: 56,
          s: [221, 239, 0]
        }],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ty: "rc",
        d: 1,
        s: {
          a: 0,
          k: [56, 56],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 4
        },
        nm: "Rectangle Path 1",
        mn: "ADBE Vector Shape - Rect",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [1, 0.764705882353, 0.874509803922, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 13,
            s: [0, 0]
          }, {
            t: 60,
            s: [100, 100]
          }],
          ix: 3
        },
        r: {
          a: 1,
          k: [{
            i: {
              x: [0.562],
              y: [1]
            },
            o: {
              x: [0.216],
              y: [0]
            },
            t: 13,
            s: [0]
          }, {
            t: 60,
            s: [-90]
          }],
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transformer "
      }],
      nm: "Rectangle 1",
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: "Triangle",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.057],
            y: [0.118]
          },
          t: 13,
          s: [205.174]
        }, {
          t: 60,
          s: [465.174]
        }],
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 13,
          s: [160, 160, 0],
          to: [0, 0, 0],
          ti: [23.043, -33.745, 0]
        }, {
          i: {
            x: 0.667,
            y: 1
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 35,
          s: [109.043, 194.755, 0],
          to: [-23.043, 33.745, 0],
          ti: [0, 0, 0]
        }, {
          t: 60,
          s: [96, 269.5, 0]
        }],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ty: "sr",
        sy: 2,
        d: 1,
        pt: {
          a: 0,
          k: 3,
          ix: 3
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 4
        },
        r: {
          a: 0,
          k: 90,
          ix: 5
        },
        or: {
          a: 0,
          k: 28,
          ix: 7
        },
        os: {
          a: 0,
          k: 0,
          ix: 9
        },
        ix: 1,
        nm: "Polystar Path 1",
        mn: "ADBE Vector Shape - Star",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [1, 0.666666666667, 0.050980392157, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.167, 0.167],
              y: [0.167, 0.167]
            },
            t: 13,
            s: [0, 0]
          }, {
            t: 60,
            s: [140, 140]
          }],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transformer "
      }],
      nm: "Polystar 1",
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: "Background",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [160, 160, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        d: 1,
        ty: "el",
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.986, 0.986],
              y: [0.929, 0.929]
            },
            o: {
              x: [0.565, 0.565],
              y: [-0.003, -0.003]
            },
            t: 8,
            s: [1, 1]
          }, {
            i: {
              x: [0.678, 0.678],
              y: [1.616, 1.616]
            },
            o: {
              x: [0.16, 0.16],
              y: [2.739, 2.739]
            },
            t: 23,
            s: [96, 96]
          }, {
            t: 47,
            s: [140, 140]
          }],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: "Tracé d'ellipse 1",
        mn: "ADBE Vector Shape - Ellipse",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: "Contour 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.094117647059, 0.109803921569, 0.129411764706, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: "Fond 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transformer "
      }],
      nm: "Ellipse 1",
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }],
  markers: []
};
export default animation;
//# sourceMappingURL=dragArea.js.map